'use client';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './types/initialState';
import { PlanTypeEnum, SubscribeInterface, listBillingInterface } from './types';
import { set } from 'lodash';

export const useClinicSlice = createSlice({
  name: 'SubscribeState',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setEditLoading: (state, action: PayloadAction<boolean>) => {
      state.editLoading = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    toggleAdd: (state, action: PayloadAction<boolean>) => {
      state.add = action.payload;
    },
    toggleDisableAccountModal: (state, action: PayloadAction<boolean>) => {
      state.disableAccount = action.payload;
    },
    toggleDeleteAccountModal: (state, action: PayloadAction<boolean>) => {
      state.deleteAccount = action.payload;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    clearFrom: (state) => {
      state.form._id = '';
      state.form.email = '';
      state.form.name = '';
    },
    setSortColumn: (state, action: PayloadAction<string>) => {
      state.sortColumn = action.payload;
    },
    setSortDir: (state, action: PayloadAction<string>) => {
      state.sortDir = action.payload;
    },
    setPlanFilterArray: (state, action: PayloadAction<[]>) => {
      state.planFilterArray = action.payload;
    },
    doAdd: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doGetList: (state) => {},
    doGetEdit: (state, action: PayloadAction<string>) => {},
    doDelete: (
      state,
      action: PayloadAction<{ id: string; callback: any }>,
    ) => {},
    doDisableAccount: (
      state,
      action: PayloadAction<{ id: string; status: number; callback: any }>,
    ) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    setList: (state, action: PayloadAction<Array<SubscribeInterface>>) => {
      state.list = action.payload;
    },
    setDataForEdit: (state, action: PayloadAction<SubscribeInterface>) => {
      state.form = action.payload;
    },

    doGetBillingList: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>,
    ) => {},
    setPageSizeBilling: (state, action: PayloadAction<number>) => {
      state.pageSizeBilling = action.payload;
    },
    setPageNoBilling: (state, action: PayloadAction<number>) => {
      state.pageNoBilling = action.payload;
    },
    setTotalRowBilling: (state, action: PayloadAction<number>) => {
      state.totalRowBilling = action.payload;
    },
    setListBilling: (state, action: PayloadAction<Array<listBillingInterface>>) => {
      state.listBilling = action.payload;
    },
    setLoadingBilling: (state, action: PayloadAction<boolean>) => {
      state.loadingBilling = action.payload;
    },
    doCancelSubscription: (
      state,
      action: PayloadAction<{id:string ,  callback: (data: any) => void }>
    ) => {},
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
